import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {SendRequestADemoForm, SendRequestADemoFormFail, SendRequestADemoFormSuccess} from './public-request-a-demo.actions';
import {
  publicRequestADemoStateDefaults,
  PublicRequestADemoStateModel,
  publicRequestADemoStateUniqueIdentifier,
} from './public-request-a-demo.model';
import {PublicRequestADemoService} from '../../services/public-request-a-demo/public-request-a-demo.service';
import {PROGRESS_STATUSES} from '../../../shared/symbols';
import {ErrorMessage} from '../../../messages/messages.actions';

@State<PublicRequestADemoStateModel>({
  name: publicRequestADemoStateUniqueIdentifier,
  defaults: publicRequestADemoStateDefaults,
})
@Injectable()
export class PublicRequestADemoState {
  constructor(private publicRequestADemo: PublicRequestADemoService) {}

  @Selector()
  static sendRequestADemoFormStatus(state: PublicRequestADemoStateModel): PublicRequestADemoStateModel['sendRequestADemoFormStatus'] {
    return state.sendRequestADemoFormStatus;
  }

  @Selector()
  static lastSendRequestADemoFormError(state: PublicRequestADemoStateModel): PublicRequestADemoStateModel['lastSendRequestADemoFormError'] {
    return state.lastSendRequestADemoFormError;
  }

  @Action(SendRequestADemoForm)
  sendRequestADemoForm(ctx: StateContext<PublicRequestADemoStateModel>, {requestADemoForm}: SendRequestADemoForm): void {
    ctx.patchState({
      sendRequestADemoFormStatus: PROGRESS_STATUSES.IN_PROGRESS,
      lastSendRequestADemoFormError: null,
    });

    this.publicRequestADemo.requestADemo(requestADemoForm).subscribe({
      next: () => ctx.dispatch(new SendRequestADemoFormSuccess()),
      error: error => ctx.dispatch(new SendRequestADemoFormFail(error)),
    });
  }

  @Action(SendRequestADemoFormSuccess)
  sendRequestADemoFormSuccess(ctx: StateContext<PublicRequestADemoStateModel>): void {
    ctx.patchState({
      sendRequestADemoFormStatus: PROGRESS_STATUSES.SUCCEED,
    });
  }

  @Action(SendRequestADemoFormFail)
  sendRequestADemoFormFail(ctx: StateContext<PublicRequestADemoStateModel>, {error}: SendRequestADemoFormFail): void {
    console.log('SendRequestADemoFormFail', error);
    ctx.patchState({
      sendRequestADemoFormStatus: PROGRESS_STATUSES.INTERRUPTED,
      lastSendRequestADemoFormError: error,
    });

    // Dispatch an error message to the user.
    ctx.dispatch(new ErrorMessage(error.message));
  }
}
